import React, { useContext } from 'react';
import Header from './Header';
import { ThemeContext } from './context/ThemeContext';
import Hero from './Hero';
import About from './About';
import Stack from './Stack'
import Projects from './Projects';
import Contact from './Contact';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const App = () => {

    const { darkMode } = useContext(ThemeContext);

    return (
        <div className={`${darkMode ? "bg-custom-gradient transition-all text-white" : 'bg-[#e4e4e4]'} relative`}>
            <ToastContainer />
            <Header />
            <Hero />
            <About />
            <Stack />
            <Projects/>
            <Contact/>
        </div>
    );
};

export default App;
